import script from "./EditProductStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProductStatus.vue?vue&type=script&setup=true&lang=ts"

import "./EditProductStatus.vue?vue&type=style&index=0&id=37b79483&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37b79483"]])

export default __exports__